import React, {useState, useEffect} from 'react'
import Cookies from 'js-cookie'
import axios from 'axios';

import { AiFillDelete } from "react-icons/ai";
import { BsPencilSquare } from "react-icons/bs";
import { RiDeleteBack2Fill } from "react-icons/ri";

import StandardForm from '../forms/StandardForm';

import  useSettingsStore  from "../../stores/SettingsStore";
import  useUserStore  from '../../stores/UserStore'

function Settings() {
    const {settings, fetchSettings} = useSettingsStore()
    const [needToFetch, setNeedToFetch] = useState(false)
    const input_list = useSettingsStore((state) => state.settingsList)

    const details = useSettingsStore((state) => state.settingsInputDetails)
    const stop_settings_list = useSettingsStore((state) => state.stopSettingList)
    const {selectSetting, selectedSetting, clearSelectedSetting, setEmptyFieldsOff, setEmptyFieldsOn} = useSettingsStore()
    const input_list2_name = "stop_settings"
    const strat = "setting"
    const btn_list = ['create / apply','remove']
    const url = "/api/make_setting"
    // const [emptyFields, setEmptyFields] = useState(false)
    // const wrappedSetEmptyFields = (value) => {
    //     setEmptyFields(value)
    //   }
   
    useEffect(() => {
        const fetchData = async () => {
            try {
                await fetchSettings()
            } catch (error) {
                console.log("Error fetching user settings", error);
            }
        }
        fetchData();
        setNeedToFetch(false)
    }, [])
    const handleShowSetting = (e) => {
        e.preventDefault();
        const setting = e.target.id 
        const details = document.getElementById(setting + "details")
        details.className = 'setting_details_container show_details'
    }
    const handleHideSetting = (e) => {
        e.preventDefault();
        const setting = e.target.id 
        const details = document.getElementById(setting + "details")
        details.className = 'setting_details_container hide_details'
    }

    const deleteSetting = async (e, setting) => {
        e.preventDefault()
        const token = Cookies.get('token')
        var data = {}
        data['button'] = "remove"    
        data['setting_name'] = setting
        try {
            await axios({
            headers: { Authorization: token },
            method: "POST",
            url : "/api/make_setting",
            data : data
            })
            } catch (err) {
            if (err.response.status === 401){                
                useUserStore.getState().logOut()    
            }                 
        } 
        setNeedToFetch(true)
    }
    const removeSelectedSetting = () => {
      clearSelectedSetting()
      setEmptyFieldsOn()
            
  }
  return (
    <div className='widget_body'>
      <ul className="settings_list">
              {settings && typeof settings === "object"
              ? Object.keys(settings).map(settingKey => (
                  <li key={settingKey + "li"} className='li setting_li'>
                      <div key={settingKey + "div"} className="setting_container">
                          <BsPencilSquare className="inline_icon no_drag" size={17} onClick={() => selectSetting(settingKey)}/>
                          <AiFillDelete className="inline_icon no_drag" onClick={(e) => deleteSetting(e, settingKey)} size={17}/>
                          <p className='setting_name no_drag' id={settingKey} onClick={() => selectSetting(settingKey)} >{settingKey.replaceAll('_', ' ')}</p>
                          {/* onMouseOver={(e) => handleShowSetting(e)} onMouseLeave={(e) => handleHideSetting(e)} */}
                          {/* <ul className='setting_details_container hide_details' id={settingKey + "details"}>
                              {Object.keys(settings[settingKey]).map(innerKey => (
                                  <li className="setting_detail_li li" key={innerKey}>
                                  {innerKey.includes("stop_settings") && Object.keys(settings[settingKey][innerKey]).length !== 0? 
                                  <div className='stop_settings_container'>
                                  <p className='setting_info stop_setting_title'> Stop Settings:</p>
                                  <ul className='stop_setting_ul'>
                                      {Object.keys(settings[settingKey][innerKey]).map(stopSetting => (
                                          <li className='li stop_setting_li'>
                                              <div className='setting_info'><p className='param_name'>{stopSetting.replaceAll('_', ' ')} : </p><p className='param_info'>{JSON.stringify(settings[settingKey][innerKey][stopSetting]).replaceAll('"', '')}</p></div>
                                          </li>
                                      ))}
                                  </ul> 
                                  </div>: 
                                  <div className='setting_info'>
                                      <p className='param_name'>{innerKey.replaceAll('_', ' ')}:</p> 
                                      <p className='param_info'>{JSON.stringify(settings[settingKey][innerKey]).replaceAll('"', '')}</p>
                                  </div>}
                                  </li>
                              ))}
                          </ul> */}
                      </div>
                  </li>
                  ))
              : null}
          </ul>
          {selectedSetting && Object.keys(selectedSetting).length !== 0 ?
              <div className='clear_selected_setting_container_std no_drag' onClick={() => removeSelectedSetting()} >
                  <h3>{selectedSetting && selectedSetting["setting_name"].replaceAll('_', ' ')} </h3>
                  <RiDeleteBack2Fill onClick={() => removeSelectedSetting()} className='inline_icon clear_selected_setting_icon_std no_drag' />
              </div>
              : null
          }
        <StandardForm
            // emptyFields={emptyFields} 
            // setEmptyFields={wrappedSetEmptyFields} 
            input_list={input_list} 
            details={details} 
            input_list2={stop_settings_list} 
            input_list2_name={input_list2_name} 
            button_list={btn_list} strat={strat} 
            url={url} 
            selectedSetting={selectedSetting}
            
        />
          
    </div>
  )
}

export default Settings;


// const input_list = [  
//   "setting_name",
//   "max_order_size", 
//   "stop_max_order_size",          
//   "price_limit_is_last_ex_price",  
//   "fill_delay",                   
//   "depth_min",
//   "depth_max", 
//   "rdm_qty_range", 
//   "aggro_order_on",
//   "aggro_depth",
//   "aggro_order_delay",
//   "aggro_book_ratio",
//   "aggro_forced_if_no_fill_in",
//   "maker_only",
//   "reduce_only",
//   "hedge_mode"
//   ]
//   const details = {
//     "setting_name": "Aggro, Slow ... anything",
//     "max_order_size": 'Order size will be capped at this value, sometimes it can round slightly over if close to min nominal.',  
//     "stop_max_order_size": 'Order size of your stops/exits.',  
//     "price_limit_is_last_ex_price": '0 or 1, \n your last exPrice becomes you price limit.',   
//     "fill_delay": 'Will wait X seconds to send another order when filled.',
//     "depth_min": 'Example: 0.001 \n how deep in the book (in %) the order is posted.',     
//     "depth_max": 'Example: 0.002 \n random between depth min/depth max (must be >= depth min).', 
//     "rdm_qty_range": 'If max order size is 1000 and rdm qty range is 20, the order size will be between 800 and 1000.',  
//     "aggro_order_on": '0 or 1, \n will allow to be taker',
//     "aggro_depth": 'With aggro order on, How deep you will try to get filled in %.',     
//     "aggro_order_delay": 'With aggro order on, \n max delay in seconds between orders.',     
//     "aggro_book_ratio": 'Example : 5,\n Ratio between bid/ask at 0.1% spread. Aggro orders will be allowed if bid vs ask ratio is > X.',     
//     "aggro_forced_if_no_fill_in": "Will force an aggro order if you didn't get filled in X seconds",  
//     "maker_only": "The order will be maker, unless it's an aggro order",
//     "hedge_mode": "0: one-way mode, 1: hedge-mode Buy side, 2: hedge-mode Sell side",
    
// }
// const stop_settings_list = [
//   "max_order_size",                    
//   "depth_min",
//   "depth_max", 
//   "cancel_price_gap",
//   "rdm_qty_range", 
//   "aggro_order_on",
//   "aggro_depth",
//   "aggro_order_delay",
//   "aggro_book_ratio",
//   "aggro_forced_if_no_fill_in",
//   "fill_delay",
//   "maker_only",
//   "reduce_only"
// ]

